import CaptureVisa from './CaptureVisa';

export default CaptureVisa;
